
import { computed, defineComponent, useFetch } from "@nuxtjs/composition-api";
import VBreadcrumb from "@/components/VBreadcrumb.vue";
// import HotProductBox from "~/components/product/HotProductBox.vue";
// import HotProductCard from "~/components/product/HotProductCard.vue";
import OperationConfiguration from "~/components/operation-configuration/index.vue";
import AppDock from '~/components/layouts/AppDock.vue'
import { useVacationHome } from "~/composables/vacation";
import { isEmpty } from "lodash";

const MAP_LINE_COLORS = [
  "linear-gradient(90deg, #005EDC 0%, #FFFFFF 100%)",
  "linear-gradient(90deg, #F25B3B 0%, #FFFFFF 100%)",
  "linear-gradient(90deg, #1F9D8B 0%, #FFFFFF 100%)",
  "linear-gradient(90deg, #FFB200 0%, #FFFFFF 100%)",
  "linear-gradient(90deg, #F2007D 0%, #FFFFFF 100%)",
];

export default defineComponent({
  name: "ProductVacationIndex",
  auth: false,
  layout: "Main",
  head: {
    title: '度假旅游'
  },
  components: {
    VBreadcrumb,
    // HotProductBox,
    // HotProductCard,
    OperationConfiguration,
    AppDock
  },
  setup() {
    const swiperOptions = {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: true,
      lazy: true,
      loop: true,
    };

    const { state, execute } = useVacationHome();

    useFetch(async () => {
      await execute();
    });

    const getBoxColor = (index: number) => {
      return MAP_LINE_COLORS[index % MAP_LINE_COLORS.length];
    };

    const modules = computed(() => state.value.content.filter((item) => !isEmpty(item.data)))
    return {
      swiperOptions,
      state,
      getBoxColor,
      modules
    };
  },
});
